var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1179_13078",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5987 14.6673C5.93736 14.6673 1.33203 10.062 1.33203 4.40065C1.33203 2.70932 2.70803 1.33398 4.3987 1.33398C4.57203 1.33398 4.74336 1.34865 4.90936 1.37732C5.07136 1.40332 5.2347 1.44465 5.3927 1.49932C5.61003 1.57465 5.7727 1.75665 5.82403 1.98065L6.73736 5.95665C6.78736 6.17532 6.72403 6.40465 6.5687 6.56732C6.47736 6.66198 6.47536 6.66398 5.6487 7.09665C6.31803 8.54598 7.48136 9.70532 8.90203 10.352C9.3347 9.52465 9.33736 9.52198 9.43203 9.43132C9.59536 9.27532 9.82537 9.21465 10.0434 9.26265L14.0194 10.1753C14.2427 10.2267 14.4247 10.3893 14.5 10.606C14.5547 10.7633 14.5954 10.926 14.6227 11.0933C14.6507 11.258 14.6654 11.4287 14.6654 11.6007C14.6654 13.292 13.29 14.6673 11.5987 14.6673",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1179_13078)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6edb044d9272248378f50f25d625481c.svg";
export { ForwardRef as ReactComponent };